import { Box } from '@mui/material';
import { FunctionComponent, useContext } from 'react';
import { AppContext } from '../../../../core/config';
import { useAppTranslate, useBusinessContext } from '../../../../core/hooks';
import { Loader } from '../../../../ui/components';
import { useChartSettings } from '../../../chart-settings/hooks';
import { BitrateStatisticsBusinessContextConfig } from '../../config';
import { useThroughputMonitoredServicesApiGet } from '../../hooks';
import { BitrateStatisticsTable } from '../BitrateStatisticsTable/BitrateStatisticsTable';
import { ViewHeader } from '../../../../core/components/ViewHeader/ViewHeader';

export const BitrateStatistics: FunctionComponent = () => {
  const { chartSettings, setResolution, setTimespan } = useChartSettings();
  const { customerId } = useContext(AppContext);
  const { throughputMonitoredServices, isFetching, isFetched } = useThroughputMonitoredServicesApiGet(customerId, chartSettings);
  const translate = useAppTranslate();
  useBusinessContext(BitrateStatisticsBusinessContextConfig);

  return <Box sx={{ p: 2 }}>
    <ViewHeader title={translate('title')} />
    {isFetching
      ? <Loader loading={isFetching} />
      : (isFetched && throughputMonitoredServices && (
          <BitrateStatisticsTable
            chartSettingsInteraction={{ chartSettings, setResolution, setTimespan }}
            customerId={ customerId }
            monitoredServices={ throughputMonitoredServices }
          />
        )
      )
    }
  </Box>;
};